import { useEffect, useState } from "react";
import { GUIDED_TOUR_SAMPLE_PDF_URL } from "./constants";

/**
 * Loads the tour sample PDF as a Blob for PdfPageViewer.
 */
export function useTourSamplePdf() {
  const [pdfBlob, setPdfBlob] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoadingPdf(true);
      setLoadError(null);
      try {
        const response = await fetch(GUIDED_TOUR_SAMPLE_PDF_URL, {
          cache: "force-cache",
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const blob = await response.blob();
        if (!cancelled) setPdfBlob(blob);
      } catch (_err) {
        if (!cancelled) {
          setPdfBlob(null);
          setLoadError("Não foi possível carregar o PDF de demonstração.");
        }
      } finally {
        if (!cancelled) setLoadingPdf(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { pdfBlob, loadingPdf, loadError };
}
